/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function SitePreview({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g stroke="currentColor" strokeWidth={1.2} clipPath="url(#SitePreview_svg__a)"><rect width={7.692} height={4.676} rx={1} transform="matrix(0 -1 -1 0 14.68 14.23)" /><path d="M9.878 10.027H2.321a1 1 0 0 1-1-1V2.77a1 1 0 0 1 1-1h9.897a1 1 0 0 1 1 1V6.6M7.27 9.972v2.502" /><path strokeLinecap="round" d="M9.94 12.459H4.92" /></g><defs><clipPath id="SitePreview_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;